<template>
  <div class="credit-table">
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Số dữ liệu mỗi trang',
        'items-per-page-options': [10, 20, 50],
      }"
      disable-sort
      :headers="headers"
      :items="creditUsages"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :server-items-length="count"
      no-data-text="Không có dữ liệu"
      @update:page="(val) => updatePagination('page', val)"
      @update:items-per-page="(val) => updatePagination('itemsPerPage', val)"
      @click:row="(item) => handleRowClick(item)"
      :expanded.sync="expandedItems"
    >
      <template v-slot:expanded-item="{ item }">
        <td colspan="12" style="background: #f6f6f6; text-align: center" class="px-0">
          <ExpenseList :creditData="item" />
        </td>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ `${moment(item.createdAt).format('DD/MM/YYYY')}, lúc ${moment(item.createdAt).format('HH:mm')}` }}
      </template>
      <template v-slot:[`item.notes`]="{ item }">
        <div v-if="item.type">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" class="trundle-text">
                {{ item.type === 'in' ? `Tính vào hoá đơn tháng ${moment().month() + 2}` : item.areaToVN }}
              </div>
            </template>
            <span class="white--text text-justify">
              {{
                item.type === 'in'
                  ? `Tính vào hoá đơn tháng ${moment().month() + 2}`
                  : `Sử dụng tại ${get(item, 'order.type', '')}`
              }}
            </span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:[`item.type`]="{ item }">
        <div :class="{ 'green--text': item.type === 'in', 'red--text': item.type === 'out' }">
          {{ item.type ? (item.type === 'in' ? 'Nạp thêm' : 'Đã sử dụng') : '' }}
        </div>
      </template>
      <template v-slot:[`item.usedCredit`]="{ item }">
        <div :class="{ 'green--text': item.type === 'in', 'red--text': item.type === 'out' }">
          {{ `${item.type === 'in' ? '+' : '-'} ${Number(item.usedCredit).toLocaleString('en-US')}` }}
        </div>
      </template>
      <template v-slot:[`item.createdBy`]="{ item }">
        <div v-if="get(item, 'createdby.name')">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                {{ item.createdby.name }}
              </div>
            </template>
            <span class="white--text text-justify">
              {{ item.createdby.name }}
            </span>
          </v-tooltip>
        </div>
        <div v-else>{{ '--' }}</div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div v-if="item.type === 'out'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" class="d-inline-flex cursor-pointer">
                <v-icon size="20" class="ml-2 icon-eye" color="primary">mdi-eye</v-icon>
              </div>
            </template>
            <span class="white--text text-justify">
              {{ 'Xem chi tiết' }}
            </span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ExpenseList from './components/ExpenseList.vue'
import { get } from 'lodash'
import moment from 'moment'
export default {
  components: { ExpenseList },
  computed: {
    ...mapState({
      creditUsages(state) {
        return state['studentCreditUsage'].creditUsages.map((v, i) => ({
          ...v,
          index: this.itemsPerPage * (this.page - 1) + i + 1,
          areaToVN: v.type === 'out' ? (v.order.type === 'canteen' ? 'Sử dụng tại căng tin' : v.order.type) : null,
        }))
      },
      itemsPerPageState(state) {
        return state['studentCreditUsage'].itemsPerPage
      },
      count(state) {
        return state['studentCreditUsage'].count
      },
      studentCredit(state) {
        return state['studentCredit'].studentCredit
      },
    }),
  },
  data() {
    return {
      headers: [
        { text: 'STT', value: 'index', align: 'center', width: '40px' },
        { text: 'Thời gian', value: 'createdAt', width: '200px' },
        { text: 'Trạng thái', value: 'type', width: '150px' },
        { text: 'Giá trị', value: 'usedCredit', width: '120px', align: 'end' },
        { text: 'Người nạp', value: 'createdBy', width: '200px' },
        { text: 'Ghi chú', value: 'notes' },
        { text: 'Thao tác', value: 'actions', align: 'center', width: '100px' },
      ],
      itemsPerPage: 10,
      page: 1,
      get,
      loading: false,
      moment,
      expandedItems: [],
      nextMonth: null,
    }
  },
  methods: {
    ...mapActions({
      setItemsPerPage: 'studentCreditUsage/setItemsPerPage',
      fetchCreditUsage: 'studentCreditUsage/fetch',
    }),
    async updatePagination(type, val) {
      this.loading = true
      try {
        const page = type === 'page' ? val : 1
        const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPageState
        await this.fetchCreditUsage({
          student: this.studentCredit.student.id,
          _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
        })
        this.setItemsPerPage(itemsPerPage)
        this.itemsPerPage = itemsPerPage
        this.page = page
      } finally {
        this.loading = false
      }
    },
    handleRowClick(item) {
      if (item.type === 'out') {
        const index = this.expandedItems.findIndex((v) => v.id === item.id)
        if (index === -1) this.expandedItems.push(item)
        else this.expandedItems.splice(index, 1)
      }
    },
    closeExpanded() {
      this.expandedItems = []
    },
  },
  watch: {
    creditUsages: {
      handler(val) {
        if (Array.isArray(val) && val.length) {
          this.closeExpanded()
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.credit-table {
  border: 1px solid rgba(0, 0, 0, 0.1);
  user-select: none;
}
.trundle-text {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
